import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colorToken", "colorTokenArgs", "customSize", "UNSAFE_svgProps"];
import React from 'react';
import Group from '@bubble-ui/primitive-group';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import { useDesignContext } from '@klarna/designtokens';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default function baseIllustration(displayName, config, useInstead) {
  var removalDate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'v6.0.0';
  var Illustration = _ref => {
    var {
        colorToken,
        colorTokenArgs,
        customSize,
        UNSAFE_svgProps
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);
    useDeprecationWarning({
      componentName: displayName,
      removalDate,
      useInstead
    });
    var size = customSize || 100;
    var designContext = useDesignContext(defaultColorVariables);
    var color = colorToken ? designContext.get(colorToken, colorTokenArgs).toString() : designContext.get('colors/text/default').toString();
    var path = config.getPath();
    return /*#__PURE__*/React.createElement(Surface, _extends({}, UNSAFE_svgProps, {
      width: size,
      height: size,
      viewBox: "0 0 100 100"
    }, props), /*#__PURE__*/React.createElement(Group, {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement(Shape, {
      d: path,
      fill: color
    })));
  };
  Illustration.displayName = displayName;
  return withProvisionalOverrideFromContext(Illustration);
}
//# sourceMappingURL=index.js.map